<template>
  <div class="dvg">
    <section class="dvg__row">
      <div class="dvg__label">
        <strong>Max. Leistung</strong>
        <span class="dvg__sub">{{ begUntertitel(tarif) }}</span>
      </div>
      <div class="dvg__value" v-if="tarif.un_name">
        <div v-for="s in begStufen(tarif)" :key="s.label" class="num">
          <span class="dvg__hint">{{ s.label }}: </span>
          <strong :class="{ 'text-green': s.frei }">{{ s.wert }}</strong>
        </div>
      </div>
    </section>

    <section class="dvg__row">
      <div class="dvg__label">
        <strong>Eckdaten</strong>
      </div>
      <div class="dvg__value" v-if="tarif.un_name">
        <div>
          Zahnersatz:
          <strong class="num">{{ tarif.tarif_leistung_ze }}%</strong>
        </div>
        <div>
          Zahnerhalt:
          <strong class="num">{{ tarif.tarif_leistung_zb }}%</strong>
        </div>
        <div>
          Prophylaxe:
          <strong class="num">{{ tarif.tarif_leistung_pzr }}%</strong>
          <span
            v-if="tarif.tarif_leistung_pzr_ohne_begrenzung == 1"
            class="dvg__chip dvg__chip--ok"
          >
            <v-icon size="12">mdi-check-bold</v-icon>
            PZR-Flatrate
          </span>
        </div>
        <div
          v-if="berechnung.ber_bleaching == 1 && tarif.tarif_beschreibung_bleaching"
        >
          <span class="text-green"><b>Bleaching:</b></span>
          <strong>{{ tarif.tarif_beschreibung_bleaching }}</strong>
        </div>
      </div>
    </section>

    <section class="dvg__row">
      <div class="dvg__label">
        <strong>Wartezeiten</strong>
      </div>
      <div class="dvg__value">
        <div>
          Zahnersatz:
          <strong>{{ tarif.tarif_beschreibung_wz_ze }}</strong>
        </div>
        <div>
          Zahnerhalt:
          <strong>{{ tarif.tarif_beschreibung_wz_zb }}</strong>
        </div>
      </div>
    </section>

    <section class="dvg__row" v-if="berechnung.ber_algo_view != 2">
      <div class="dvg__label">
        <strong>Hightech-Leistungen</strong>
      </div>
      <div class="dvg__value">
        <ul class="dvg__list" v-if="tarif.highspezial">
          <li v-for="item in tarif.highspezial" :key="item.id">
            <span v-if="item.ja">
              <v-icon size="13" class="dvg__icon dvg__icon--ok">
                mdi-check-bold
              </v-icon>
              {{ item.value }}
            </span>
            <span v-if="!item.ja" class="dvg__strike">
              <v-icon size="13" class="dvg__icon dvg__icon--off">
                mdi-close
              </v-icon>
              {{ item.value }}
            </span>
          </li>
        </ul>
      </div>
    </section>

    <section class="dvg__row" v-if="berechnung.ber_algo_view != 2">
      <div class="dvg__label">
        <strong>Kinder-Leistungen</strong>
      </div>
      <div class="dvg__value">
        <ul class="dvg__list">
          <li v-for="item in tarif.kindspezial" :key="item.id">
            <span v-if="item.ja">
              <v-icon size="13" class="dvg__icon dvg__icon--ok">
                mdi-check-bold
              </v-icon>
              {{ item.value }}
            </span>
            <span v-if="!item.ja" class="dvg__strike">
              <v-icon size="13" class="dvg__icon dvg__icon--off">
                mdi-close
              </v-icon>
              {{ item.value }}
            </span>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useBegrenzung } from "@/composable/useBegrenzung";
  const { stufen: begStufen, untertitel: begUntertitel } = useBegrenzung();

  const props = defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });
  console.log(props.tarif);
</script>

<style scoped>
  .dvg {
    background: #fff;
    border: 1px solid var(--wz-border);
    border-radius: 3px;
    overflow: hidden;
  }
  .dvg__row {
    display: grid;
    grid-template-columns: 200px minmax(0, 1fr);
    gap: 16px;
    padding: 10px 14px;
    border-bottom: 1px dashed var(--wz-border-3);
    align-items: start;
  }
  .dvg__row:last-child {
    border-bottom: none;
  }
  .dvg__label {
    font-size: 13px;
    color: var(--wz-ink-3);
    line-height: 1.45;
    display: flex;
    flex-direction: column;
  }
  .dvg__label strong {
    color: var(--wz-ink);
  }
  .dvg__sub {
    font-size: 12px;
    color: var(--wz-ink-5);
    margin-top: 2px;
  }
  .dvg__value {
    font-size: 13px;
    color: var(--wz-ink-2);
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .dvg__value strong {
    color: var(--wz-ink);
  }
  .dvg__hint {
    font-size: 12px;
    color: var(--wz-ink-5);
  }

  .dvg__list {
    margin: 0;
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .dvg__list li {
    font-size: 13px;
    line-height: 1.5;
    padding: 2px 0;
  }
  .dvg__icon {
    margin-right: 6px;
    vertical-align: -2px;
  }
  .dvg__icon--ok {
    color: var(--wz-green) !important;
  }
  .dvg__icon--off {
    color: var(--wz-red) !important;
  }
  .dvg__strike {
    color: var(--wz-ink-5);
    text-decoration: line-through;
  }

  .dvg__chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 1px 8px;
    margin-left: 6px;
    background: var(--wz-green-bg);
    border: 1px solid var(--wz-green-border);
    color: var(--wz-green);
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    border-radius: 3px;
  }

  .num {
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 780px) {
    .dvg__row {
      grid-template-columns: 1fr;
      gap: 4px;
      padding: 10px 0;
    }
    .dvg__label {
      font-size: 12.5px;
    }
    .dvg__value {
      font-size: 13.5px;
    }
  }
</style>
